import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
  return (
    <Box component="footer" sx={{ backgroundColor: 'white', mt: 'auto', borderTop: '1px solid #e0e0e0' }}>
      <Container maxWidth="xl" className="py-12">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <img 
              src="/2.png" 
              alt="Meiyal Foundation Logo" 
              loading="lazy"
              style={{ 
                height: '60px', 
                marginBottom: '16px',
                objectFit: 'contain'
              }} 
            />
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1A4D2E' }}>
              Meiyal Foundation
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
              Empowering women and children in plantation communities through education,
              leadership, and welfare support.
            </Typography>
            <div className="flex space-x-2">
              <IconButton 
                sx={{ 
                  color: '#1A4D2E',
                  '&:hover': { color: '#C4A484' },
                  transition: 'color 0.3s'
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton 
                sx={{ 
                  color: '#1A4D2E',
                  '&:hover': { color: '#C4A484' },
                  transition: 'color 0.3s'
                }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton 
                sx={{ 
                  color: '#1A4D2E',
                  '&:hover': { color: '#C4A484' },
                  transition: 'color 0.3s'
                }}
              >
                <InstagramIcon />
              </IconButton>
            </div>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1A4D2E' }}>
              Quick Links
            </Typography>
            <ul className="space-y-2 list-none p-0">
              <li>
                <Link to="/" style={{ color: '#666', textDecoration: 'none' }} className="hover:text-secondary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" style={{ color: '#666', textDecoration: 'none' }} className="hover:text-secondary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/programs" style={{ color: '#666', textDecoration: 'none' }} className="hover:text-secondary transition-colors">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/membership" style={{ color: '#666', textDecoration: 'none' }} className="hover:text-secondary transition-colors">
                  Membership
                </Link>
              </li>
              <li>
                <Link to="/leadership" style={{ color: '#666', textDecoration: 'none' }} className="hover:text-secondary transition-colors">
                  Leadership
                </Link>
              </li>
            </ul>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1A4D2E' }}>
              Contact Us
            </Typography>
            <div className="space-y-3">
              <div className="flex items-start">
                <LocationOnIcon sx={{ mr: 1, mt: 0.5, color: '#1A4D2E' }} fontSize="small" />
                <Typography variant="body2" sx={{ color: '#666' }}>
                  No 1, Commercial Place, Kotagala<br />
                  Sri Lanka
                </Typography>
              </div>
              <div className="flex items-center">
                <PhoneIcon sx={{ mr: 1, color: '#1A4D2E' }} fontSize="small" />
                <Typography 
                  variant="body2" 
                  component="a"
                  href="tel:+94766637892"
                  sx={{ 
                    color: '#666',
                    textDecoration: 'none',
                    '&:hover': {
                      color: '#1A4D2E',
                      textDecoration: 'underline',
                    }
                  }}
                >
                  +94 766637892
                </Typography>
              </div>
              <div className="flex items-center">
                <EmailIcon sx={{ mr: 1, color: '#1A4D2E' }} fontSize="small" />
                <Typography 
                  variant="body2"
                  component="a"
                  href="mailto:meiyalfoun@gmail.com"
                  sx={{ 
                    color: '#666',
                    textDecoration: 'none',
                    '&:hover': {
                      color: '#1A4D2E',
                      textDecoration: 'underline',
                    }
                  }}
                >
                  meiyalfoun@gmail.com
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box sx={{ borderTop: '1px solid #e0e0e0', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#999' }}>
            © {new Date().getFullYear()} Meiyal Foundation. All rights reserved. | Non-Profit & Non-Political Organization
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
